/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* CLEAR CART DRAWER  */
const clearBtn = document.querySelector('[data-clear-cart]');

function clearCart() {
    fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({}),
    })
        .then((res) => { console.log(res), res.json() })
        .then(() => document.documentElement.dispatchEvent(new CustomEvent("cart:refresh")));
}


clearBtn.addEventListener('click', (event) => {
    event.preventDefault();
    clearCart()
});

// -------------------

/* CART TERMS AND CONDITIONS */
const termsOverlay = document.querySelector('.terms-overlay');
const termsContent = document.querySelector('.terms-content-wrapper');
const termsDeny = document.querySelector('.terms-deny');
const termsAccept = document.querySelector('.terms-accept');

function showTerms() {
    termsOverlay.classList.add('terms-overlay--active');
    termsContent.classList.add('terms-content-wrapper--active');
}

function hideTerms() {
    termsOverlay.classList.remove('terms-overlay--active');
    termsContent.classList.remove('terms-content-wrapper--active');
}
function validateTerms(e) {
    e.preventDefault();
    const cartTerms = document.querySelector('input[name=checkbox]');

    if (cartTerms.checked) {
        window.location = '/checkout';
    } else {
        showTerms();
    }
}

termsOverlay?.addEventListener('click', () => {
    hideTerms();
});

termsAccept?.addEventListener('click', () => {
    window.location = '/checkout';
});

termsDeny?.addEventListener('click', () => {
    hideTerms();
});

// -------------------

// GEO JS fjernet 09-2026 - erstattet af sprogvaelgeren i headeren (snippets/locale-switcher.liquid)

//   const productItemImage = document.querySelectorAll(".ProductItem__Image");
//   const productItem = document.querySelectorAll(".ProductItem");

//   productItem?.forEach((item)=>{
//       if(item.outerText.includes("DISORDER")){
//         item.parentElement.classList.add("hide");
//         item.classList.add("hide");
//       }
//   })

